import { render } from "./CertAlertCarousselVertical.vue?vue&type=template&id=3ca3fd8b"
import script from "./CertAlertCarousselVertical.vue?vue&type=script&lang=js"
export * from "./CertAlertCarousselVertical.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\cert-v3\\cert\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__